export class Result {
    items = [];
    total = 0;
    pageNum = 1;
}
